import { BaseCardCollapsible } from 'commons/components';

function Skeleton() {
  return (
    <>
      <BaseCardCollapsible.Skeleton />
      <BaseCardCollapsible.Skeleton />
      <BaseCardCollapsible.Skeleton />
    </>
  );
}

export default Skeleton;
